import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { useSetAtom } from 'jotai';
import React from 'react';
import { useIsomorphicLayoutEffect } from '@pairy/react-hooks';

import {
  isDisableHelpersAtom,
  pdfViewerModeAtom,
} from '../../../store/index.atom';

import * as Styled from './index.styles';

export interface RootProps {
  mode: 'mobile' | 'desktop';
  isActiveHelpers?: boolean;
}

const Root = ({
  isActiveHelpers,
  mode,
  children,
}: React.PropsWithChildren<RootProps>) => {
  const setPdfViewerMode = useSetAtom(pdfViewerModeAtom);
  const setIsDisableHelpers = useSetAtom(isDisableHelpersAtom);

  useIsomorphicLayoutEffect(() => {
    setPdfViewerMode(mode);

    const { body } = document;

    disableBodyScroll(body, {
      allowTouchMove: () => true,
    });

    return () => {
      enableBodyScroll(body);
    };
  }, [mode, setPdfViewerMode]);

  /*doc-height로 브라우저의 높이 값을 등록해서 
  FlexMain 스타일 컴포넌트에서 height를 doc-height로 주고 있음*/
  useIsomorphicLayoutEffect(() => {
    const documentHeight = () => {
      const doc = document.documentElement;
      doc.style.setProperty('--doc-height', `${window.innerHeight}px`);
    };

    if (mode === 'mobile') {
      documentHeight();
    }

    window.addEventListener('resize', documentHeight);

    return () => {
      window.removeEventListener('resize', documentHeight);
    };
  }, [mode]);

  return (
    <Styled.FlexMain
      as="main"
      direction={mode === 'mobile' ? 'column' : 'row'}
      onClick={() => {
        if (isActiveHelpers) {
          setIsDisableHelpers(false);
          return;
        }
        setIsDisableHelpers((prev) => !prev);
      }}
    >
      {children}
    </Styled.FlexMain>
  );
};

export default Root;
